<template>
  <v-checkbox
    ref="checkbox"
    v-bind="{ ...$props, ...$attrs }"
    @update:model-value="change"
  />
</template>
<script>
export default {
  name: 'DpplCheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:model-value'],
  data() {
    return {
      checked: this.modelValue,
    };
  },
  mounted() {
    const label = this.$refs.checkbox.$el.querySelector('.v-label');
    const h5 = document.createElement('H5');
    if (label) {
      while (label.childNodes.length > 0) {
        h5.appendChild(label.childNodes[0]);
      }
      label.appendChild(h5);
      label.classList.add('text-textDarkest');
    }
  },
  methods: {
    change() {
      this.checked = !this.checked;
      this.$emit('update:model-value', this.checked);
    },
  },
};
</script>

<style scoped lang="less">
:deep(.v-label) {
  opacity: 1;
}
</style>
